import firebase from 'firebase/app'
import 'firebase/firestore';

import 'firebase/firestore'

const config = {
  apiKey: "AIzaSyBcNyAdbdTVljOf7jPqoBIqD2_TxeDModg",
  authDomain: "splendor-adc85.firebaseapp.com",
  databaseURL: "https://splendor-adc85.firebaseio.com",
  projectId: "splendor-adc85",
  storageBucket: "splendor-adc85.appspot.com",
  messagingSenderId: "585677912907"
};
firebase.initializeApp(config)

const db = firebase.firestore()
const settings = { timestampsInSnapshots: true};
db.settings(settings);

export {
  db,
}
